var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M44.264 6.56L19.736 32l24.528 25.44","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronLeftInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
